import { useEffect } from "react";

import { client } from "@/utils/orpc.client";

const VIEW_DEBOUNCE_MS = 30 * 60 * 1000;

function wasRecentlyViewed(entityType: string, entityId: string): boolean {
  const key = `view:${entityType}:${entityId}`;
  const stored = sessionStorage.getItem(key);
  if (!stored) return false;
  return Date.now() - Number(stored) < VIEW_DEBOUNCE_MS;
}

function markViewed(entityType: string, entityId: string) {
  sessionStorage.setItem(`view:${entityType}:${entityId}`, String(Date.now()));
}

/**
 * Records a page view for trending calculations.
 * Fires for all visitors (including anonymous), debounced per entity via sessionStorage.
 */
export function useRecordView(
  entityType: "artist" | "work" | "release" | "company",
  entityId: string | undefined,
) {
  useEffect(() => {
    if (entityId == null) return;

    if (wasRecentlyViewed(entityType, entityId)) return;

    markViewed(entityType, entityId);
    client.music.recordView({ entityType, entityId });
  }, [entityType, entityId]);
}
